<template>
	<div id="app">
		<notifications />
		<router-view @fetchAuthInfo="fetchAuthInfo" />
	</div>
</template>

<script>
import { mapActions } from 'vuex'
import './app.scss'

export default {
	methods: {
		...mapActions('auth', ['fetchAuthInfo']),
	},
	async created() {
		if (this.$route.name !== 'Login') {
			try {
				await this.fetchAuthInfo()
			} catch {
				localStorage.removeItem('x-backend-auth')
				this.$router.push('/login')
			}
		}
	},
}
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Sarabun:wght@400;600;800&display=swap');
@import url('https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.13.0/css/all.min.css');

* {
	box-shadow: none !important;
}
body {
	font-family: 'Sarabun', sans-serif !important;
}
.alert-notify {
	align-items: center !important;
}
.router-link-exact-active {
	color: #5e72e4 !important;
	font-weight: bolder !important;
}
.dropdown-item {
	display: flex !important;
	align-items: center;
}
.form-group {
	margin-bottom: 0.75rem !important;
}
.el-input__inner {
	height: calc(1.5em + 1.25rem + 5px) !important;
}
.timeline-step {
	transform: none !important;
	left: 0 !important;
	width: 75px !important;
	font-weight: normal !important;
	border-radius: 4px !important;
}
.timeline-content {
	margin-left: 100px !important;
	width: calc(100% - 75px) !important;
	float: left !important;
	max-width: 100% !important;
}
.timeline-one-side {
	&::before {
		left: 2.5rem !important;
	}
}
.tl-badge {
	font-weight: bold !important;
	min-width: 60px;
}
.custom-control-label {
	line-height: 1.5rem;
}
.el-table.bordered {
	border-left: 1px solid #eee !important;
	border-right: 1px solid #eee !important;
}
.btn {
	transform: none !important;
}

@media screen and (min-width: 720px) {
	dt {
		margin-bottom: 15px;
	}
	.search {
		button {
			margin-top: 18px;
		}
	}
}
</style>
